// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import Fetch from '@/utils/Fetch';
import Breadcrumbs from '@/components/breadcrumbs';
import KendoScheduler from '@/components/kendo/scheduler/kendo-scheduler';
import DraggableJobCard from '@/components/draggable/draggable-job-card';
import TextInput from '@/components/text-input';
import Tabs from '@/components/tabs';
import DraggableEmployee from '@/components/draggable/draggable-employee';
import SubscriptionContext from '@/utils/subscription-context';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import DraggableStore from '@/components/draggable/draggable-store';
import Accordion from '@/components/accordion';
import { colors } from '@/theme';
import Checkbox from '@/components/checkbox';
import Button from '@/components/button';
import Router from 'next/router';
import Helper from '@/utils/helper';
import UCS from '@/services/option/user-config-service';
import PageContext from '@/utils/page-context';
import MessagePost from '@/components/modals/message-post';
import NoSSR from '@/utils/no-ssr';
import PS from '@/services/permission/permission-service';
import DownloadDropDown from '@/components/download-dropdown';
import ExportSchedules from '@/components/modals/appointment/export-schedules';
import DownloadService from '@/utils/download-service';
import SCDropdownList from '@/components/sc-controls/form-controls/sc-dropdownlist';
import useInitialTimeout from '@/hooks/useInitialTimeout';
import { createFileRoute } from '@tanstack/react-router'



const slotDurationOptions = [{
    value: 4, label: "15min"
},
{
    value: 2, label: "30min"
}];

function AppointmentScheduler(props: any) {

    const subscriptionContext = useContext(SubscriptionContext);
    const pageContext = useContext(PageContext);
    const initialTimeout = useInitialTimeout(500);

    const [exportPermission] = useState(PS.hasPermission(Enums.PermissionName.Exports));

    const tabNames = {
        filters: "Filters",
        jobs: "Jobs"
    };

    const [filtersConfig, setFiltersConfig] = useState<any>(null);
    const [activeFilterIdsDefault, setActiveFilterIdsDefault] = useState<any>({});
    const [searching, setSearching] = useState(false);
    const [appointments, setAppointments] = useState<any[]>([]);
    const [jobs, setJobs] = useState<any[]>([]);
    const [searchPhrase, setSearchPhrase] = useState("");
    const [selectedItemID, setSelectedItemID] = useState<any>(null);
    const [selectedTab, setSelectedTab] = useState(tabNames.filters);
    const [stores, setStores] = useState<any[]>([]);
    const [selectedStores, setSelectedStores] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);
    const [startRange, setStartRange] = useState<any>(null);
    const [endRange, setEndRange] = useState<any>(null);
    const [employeeID] = useState(Storage.getCookie(Enums.Cookie.employeeID));
    const [showFilters, setShowFilters] = useState(true);
    const [unassignedSelected, setUnassignedSelected] = useState(true);
    const [onlyUnscheduledJobs, setOnlyUnscheduledJobs] = useState(true);
    const pageIndex = useRef(0);
    const [defaultView, setDefaultView] = useState<any>(null);
    const [searchingJobs, setSearchingJobs] = useState(false);
    const [canShowMore, setCanShowMore] = useState(false);

    const [userFullName] = useState(Storage.getCookie(Enums.Cookie.servFullName));
    const [exportOptions, setExportOptions] = useState<any[]>([]);
    const [showExport, setShowExport] = useState(false);

    const [slotDuration, setSlotDuration] = useState(slotDurationOptions.find((x: any) => x.value === 2));

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const getAccessStatus = () => {
        let subscriptionInfo = subscriptionContext.subscriptionInfo!!!;
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    }

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    useEffect(() => {
        const init = async () => {
            const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
            const isMultiStore = subscriptionInfo ? subscriptionInfo.MultiStore : false;

            const [filtersConfigResult, employeeResults, storeResults] = await Promise.all([
                UCS.getPageFilters(Enums.ConfigurationSection.Appointment),
                Fetch.get({ url: '/Employee/GetEmployees' }),
                isMultiStore ? Fetch.get({
                    url: "/Store/GetEmployeeStores",
                    params: {
                        employeeID: Storage.getCookie(Enums.Cookie.employeeID),
                        searchPhrase: "",
                        showAll: false
                    }
                }) : Promise.resolve(null)
            ]);

            const [activeFilterIdsResult] = UCS.getFilterValues(filtersConfigResult,
                ["Employees", "Stores", "UnassignedEmployee", "DefaultView", "DefaultPage"], []);

            const loadedEmployees = employeeResults.Results || [];
            const loadedStores = storeResults ? storeResults.Results : [];

            setFiltersConfig(filtersConfigResult);
            setActiveFilterIdsDefault(activeFilterIdsResult);
            setEmployees(loadedEmployees);
            setSelectedEmployees([...loadedEmployees]);
            setStores(loadedStores);
            setSelectedStores([...loadedStores]);
            setDefaultView(
                activeFilterIdsResult.DefaultView && activeFilterIdsResult.DefaultView.length === 1
                    ? activeFilterIdsResult.DefaultView[0]
                    : Enums.SchedulerView.workweek
            );
        };

        getAccessStatus();
        setExportOptionsList();
        setSlotDuration(getSlotDuration());
        init();
    }, []);

    const getSlotDuration = () => {

        if (typeof window === "undefined") return;

        let localSlotDuration = window.localStorage.getItem(Enums.LocalStorage.SchedulerSlotDuration);

        if (localSlotDuration) {
            return JSON.parse(localSlotDuration);
        }

        return slotDurationOptions.find((x: any) => x.value === 2);
    };

    const updateSlotDuration = (newSlotDuration: any) => {

        if (typeof window === "undefined") return;

        setSlotDuration(newSlotDuration);

        window.localStorage.setItem(Enums.LocalStorage.SchedulerSlotDuration, JSON.stringify(newSlotDuration));
    };

    useEffect(() => {
        if (selectedTab === tabNames.jobs) {
            searchJobs();
        }
    }, [selectedTab]);

    const setExportOptionsList = () => {
        let exportOpts = [];
        setExportOptions(exportOpts);
    };

    const exportSchedules = async (params: any) => {
        await DownloadService.downloadFile("POST", "/Appointment/GetExportedAppointments", params, false, false);
    }

    const debounce = useRef<any>(null);
    const oldSearchPhrase = useRef("");
    const oldOnlyUnscheduledJobs = useRef("");

    useEffect(() => {
        clearTimeout(debounce.current);

        debounce.current = setTimeout(() => {
            searchJobs(false);
        }, oldSearchPhrase.current !== searchPhrase ? 500 : 1);

        oldSearchPhrase.current = searchPhrase;
        oldOnlyUnscheduledJobs.current = onlyUnscheduledJobs;

    }, [searchPhrase, onlyUnscheduledJobs]);

    const showMore = () => {
        searchJobs(true);
    };

    const searchJobs = async (newPage = false) => {

        if (!initialTimeout) return;

        if (newPage) {
            pageIndex.current++;
        } else {
            pageIndex.current = 0;
        }

        setSearchingJobs(true);
        const jobResults = await Fetch.post({
            url: '/Job/GetJobs',
            params: {
                SearchPhrase: searchPhrase,
                SortExpression: searchPhrase ? "JobCardNumber" : "StartDate",
                SortDirection: searchPhrase ? "ascending" : "descending",
                PageSize: 10,
                PageIndex: pageIndex.current,
                ShowArchived: false,
                IncludeClosed: false,
                PopulateAppointments: true,
                OnlyUnscheduledJobs: onlyUnscheduledJobs
            }
        });

        let results = [];
        if (newPage) {
            results = [...jobs];
        }
        if (!!jobResults.Results) {
            results.push(...jobResults.Results);
        }

        setCanShowMore(jobResults.TotalResults > results.length);
        setJobs(results);

        if (!!results) {
            let selectedJobIDx = results.findIndex((x: any) => x.ID === selectedItemID);
            if (selectedJobIDx < 0) {
                setSelectedItemID(null);
            }
        }

        setSearchingJobs(false);
    };

    const searchAppointments = async (start: any, end: any, view: any) => {
        setSearching(true);

        setStartRange(start);
        setEndRange(end);
        setDefaultView(view);

        const paramsToSend = {
            pageSize: 999,
            pageIndex: 0,
            StartDateTime: start,
            EndDateTime: end,
            EmployeeIDList: selectedEmployees !== null ? selectedEmployees.map((x: any) => x.ID) : null,
            StoreIDList: selectedStores !== null ? selectedStores.map((x: any) => x.ID) : null,
            IncludeUnassigned: unassignedSelected
        };

        const activeFilterIds = {
            Employees: activeFilterIdsDefault.Employees,
            Stores: activeFilterIdsDefault.Stores,
            UnassignedEmployee: [true],
            DefaultView: [view],
            DefaultPage: ["/appointment/scheduler"]
        };

        if (selectedEmployees && selectedEmployees.length === 0 && !unassignedSelected ||
            (subscriptionContext.subscriptionInfo!!! && subscriptionContext.subscriptionInfo.MultiStore!!! && selectedStores && selectedStores.length === 0)) {
            setAppointments([]);
        } else {
            const appointmentResults = await Fetch.post({
                url: `/Appointment/GetAppointments`,
                params: paramsToSend
            });
            setAppointments(appointmentResults.Results ? appointmentResults.Results : []);
        }

        let filtersConfigTemp = { ...filtersConfig };
        UCS.updateFilters(filtersConfigTemp, activeFilterIds);
        UCS.saveConfigDebounced(filtersConfigTemp);
        setFiltersConfig(filtersConfigTemp);

        setSearching(false);
    };

    const onDateRangeChange = (start: any, end: any, view: any) => {
        searchAppointments(start, end, view);
        searchJobs(false);
    };

    const toggledEmployee = useRef(false);

    const toggleEmployee = useCallback((employee: any) => {
        let selectedEmployeesTemp = [...selectedEmployees];
        let idx = selectedEmployeesTemp.findIndex((x: any) => x.ID === employee.ID);
        if (idx > -1) {
            selectedEmployeesTemp.splice(idx, 1);
        } else {
            selectedEmployeesTemp.push(employee);
        }
        setSelectedEmployees(selectedEmployeesTemp);
    });

    const debounceTimeout = useRef<any>(null);
    useEffect(() => {
        if (toggledEmployee.current && toggledStore.current) {
            clearTimeout(debounceTimeout.current);

            debounceTimeout.current = setTimeout(() => {
                searchAppointments(startRange, endRange, defaultView);
            }, 100);
        }
    }, [selectedEmployees, selectedStores, unassignedSelected]);


    useEffect(() => {
        setTimeout(() => {
            toggledStore.current = true;
            toggledEmployee.current = true;
        }, 500);
    }, [employees]);

    const toggledStore = useRef(false);

    const toggleStore = useCallback((store: any) => {
        let selectedStoresTemp = [...selectedStores];
        let idx = selectedStoresTemp.findIndex((x: any) => x.ID === store.ID);
        if (idx > -1) {
            selectedStoresTemp.splice(idx, 1);
        } else {
            selectedStoresTemp.push(store);
        }
        setSelectedStores(selectedStoresTemp);
    });

    const selectAllStores = () => {
        let selectedStoresTemp = selectedStores.length === stores.length ? [] : [...stores];
        setSelectedStores(selectedStoresTemp);
    };

    const selectAllEmployees = () => {
        let selectedEmployeesTemp = selectedEmployees.length === employees.length ? [] : [...employees];
        setSelectedEmployees(selectedEmployeesTemp);
        setUnassignedSelected(selectedEmployeesTemp.length > 0);
    };

    const jobDragOrClick = useCallback((job: any, onDrag: any) => {
        if (!job || !job.Employees || job.Employees.length === 0 ||
            (!onDrag && (!job.Appointments || job.Appointments.length === 0))) return;

        let selectedEmployeesTemp = [...selectedEmployees];
        let employeeIDs = job.Employees.map((x: any) => x.ID);
        employeeIDs.forEach((id: any) => {
            let employee = employees.find((x: any) => x.ID === id);
            if (employee) {
                let selectedIdx = selectedEmployeesTemp.findIndex((x: any) => x.ID === id);
                if (selectedIdx < 0) {
                    selectedEmployeesTemp.push(employee);
                }
            }
        });

        let selectedStoresTemp = [...selectedStores];
        let storeIDs = job.Appointments && job.Appointments.length > 0 ? job.Appointments.map((x: any) => x.StoreID) : [job.StoreID];
        storeIDs.forEach((id: any) => {
            let store = stores.find((x: any) => x.ID === id);
            if (store) {
                let selectedIdx = selectedStoresTemp.findIndex((x: any) => x.ID === id);
                if (selectedIdx < 0) {
                    selectedStoresTemp.push(store);
                }
            }
        });

        setSelectedEmployees(selectedEmployeesTemp);
        setSelectedStores(selectedStoresTemp);
    });

    return (
        <>
            <div className="list-container">
                <div className="row">
                    <div className="title">
                        <Breadcrumbs currPage={{ text: 'Scheduler', link: '/appointment/scheduler', type: 'list' }} />
                    </div>
                    <NoSSR>
                        <div className="button-container">
                            <div style={{ marginTop: "-7px", transform: "scale(0.75)", display: "flex" }}>
                                <div style={{ width: "140px", marginTop: "19px" }}>Slot Duration</div>
                                <SCDropdownList
                                    name="schedulerInterval"
                                    dataItemKey='value'
                                    textField='label'
                                    value={slotDuration}
                                    onChange={(e: any) => updateSlotDuration(e)}
                                    options={slotDurationOptions}
                                />
                            </div>
                            {subscriptionContext.subscriptionInfo!!! && subscriptionContext.subscriptionInfo.AccessStatus!!! !== Enums.AccessStatus.LockedWithAccess && subscriptionContext.subscriptionInfo.AccessStatus!!! !== Enums.AccessStatus.LockedWithOutAccess && exportPermission ? <>
                                <div className="download">
                                    <DownloadDropDown title={'Export'} options={exportOptions} handleClick={() => setShowExport(true)} extraClasses="compact" />
                                </div>
                            </> : ''}
                        </div>
                    </NoSSR>
                </div>
                <div className="row">
                    <img src="/icons/hamburger.svg" className="hamburger-accordion"
                        title={showFilters ? "Hide filters" : "Show filters"}
                        onClick={() => setShowFilters(!showFilters)} />

                    <div className="filter-container">
                        <div className="filter">
                            <Tabs
                                noMarginTop={true}
                                selectedTab={selectedTab}
                                setSelectedTab={setSelectedTab}
                                tabs={[
                                    { text: tabNames.filters, fitContent: true },
                                    { text: tabNames.jobs, suppressCount: true, fitContent: true }
                                ]} />
                        </div>

                        {(() => {
                            switch (selectedTab) {
                                case tabNames.jobs:
                                    return (<>
                                        <div className="filter">
                                            <TextInput
                                                extraClasses="no-margin-top search-style"
                                                label="Search Jobs"
                                                placeholder={onlyUnscheduledJobs ? "Getting unscheduled jobs" : "Getting latest jobs"}
                                                value={searchPhrase}
                                                changeHandler={(e: any) => setSearchPhrase(e.target.value)}
                                            />

                                            <Checkbox label="Unscheduled Jobs" checked={onlyUnscheduledJobs} changeHandler={() => setOnlyUnscheduledJobs(!onlyUnscheduledJobs)}
                                                extraClasses="top-margin" />
                                        </div>
                                        <div className="scrollable-job" style={{ opacity: (searchingJobs ? 0.3 : 1) }}>
                                            {jobs && jobs.map((job: any, idx: any) => {
                                                return <DraggableJobCard job={job} key={idx} onDragOrClick={jobDragOrClick}
                                                    setSelectedItemID={setSelectedItemID} selectedItemID={selectedItemID} />
                                            })}

                                            {canShowMore ? <>
                                                <div className="infinite-scroll-button" onClick={showMore}>
                                                    Load more
                                                </div>
                                            </> : ""}
                                        </div>
                                    </>);
                                case tabNames.filters:
                                    return (<NoSSR>
                                        <div className="scrollable-filter">
                                            {subscriptionContext.subscriptionInfo!!! && subscriptionContext.subscriptionInfo.MultiStore!!! ?
                                                <>
                                                    <h4>Filter by Store <span className="select-all" onClick={selectAllStores}>Select All</span></h4>
                                                    <Accordion width="273px">
                                                        {stores && stores.sort((a: any, b: any) => {
                                                            if (a.IsDefault) return -1;
                                                            return a.Name - b.Name;
                                                        }).map((store: any, idx: any) => {
                                                            return <DraggableStore store={store} key={idx + employees.length}
                                                                isSelected={selectedStores && selectedStores.findIndex((x: any) => x.ID === store.ID) > -1} setSelected={toggleStore} />
                                                        })}
                                                    </Accordion>
                                                </> : ""}
                                            <h4>Filter by Employee <span className="select-all" onClick={selectAllEmployees}>Select All</span></h4>
                                            <Accordion width="273px">
                                                <DraggableEmployee employee={{ FullName: "Unassigned" }} key={-1} isUnassigned={true}
                                                    isSelected={unassignedSelected} setSelected={() => setUnassignedSelected(!unassignedSelected)} />
                                                {employees && employees.map((employee: any, idx: any) => {
                                                    return <DraggableEmployee employee={employee} key={idx}
                                                        isSelected={selectedEmployees && selectedEmployees.findIndex((x: any) => x.ID === employee.ID) > -1} setSelected={toggleEmployee} />
                                                })}
                                            </Accordion>
                                        </div>
                                    </NoSSR>);
                            }

                        })()}

                    </div>
                    <div className="schedule-container">
                        <KendoScheduler data={appointments} onDateRangeChange={onDateRangeChange} slotDivisions={slotDuration?.value}
                            selectedItemID={selectedItemID} defaultView={defaultView ? defaultView : Enums.SchedulerView.workweek}
                            accessStatus={subscriptionContext.subscriptionInfo!!! ? subscriptionContext.subscriptionInfo.AccessStatus!!! : Enums.AccessStatus.LockedWithOutAccess} />
                    </div>
                </div>
            </div>

            {showExport ?
                <ExportSchedules
                    onConfirm={exportSchedules}
                    setShowExport={setShowExport}
                /> : ""}

            <style jsx>{`
    .column {
      width: 100%;
    }
    .row {
      position: relative;
      display: flex;
      justify-content: space-between;
    }
    .filter-container {
      width: ${showFilters ? "300px" : "0"};
      overflow: hidden;
      transition-duration: 0.5s; 
    }

    .infinite-scroll-button {
        margin: 0.5rem;
        cursor: pointer;
        font-weight: bold;
    }

    .infinite-scroll-button:hover {
        text-decoration: underline;
    }

    .select-all {
        font-size: 10px;
        padding: 4px 6px;
        background: ${colors.formGrey};
        float: right;
        margin-right: 20px;
        border-radius: 3px;
        cursor: pointer;
    }

    .select-all:hover {
        background: ${colors.borderGrey};
    }
    
    .schedule-container {
      width: ${showFilters ? "calc(100% - 300px)" : "100%"};
      transition-duration: 0.5s;
    }

    .hamburger-accordion {
      position: absolute;
      left: ${showFilters ? "273px" : "-25px"};
      top: 0;
      background: #82b3eb;
      border-radius: 3px;
      cursor: pointer;
      padding: 1px;
      width: 24px;
      height: 36px;
      transition-duration: 0.5s;
    }

    .filter {
      width: 273px;
      margin-bottom: 8px;
    }

    .scrollable-job {
      max-height: calc(100vh - 262px);
      overflow: auto;
    }
    
    .scrollable-filter {
      max-height: calc(100vh - 170px);
      overflow: auto;
    }

    .scrollable-job::-webkit-scrollbar, .scrollable-filter::-webkit-scrollbar {
      background: transparent;
      width: 8px;
      margin-right: 8px;
    }

    .scrollable-job::-webkit-scrollbar-thumb, .scrollable-filter::-webkit-scrollbar-thumb {
      background: ${colors.bluePrimary}22;
      border-radius: 3px;
    }

    .scrollable-job:hover::-webkit-scrollbar-thumb, .scrollable-filter:hover::-webkit-scrollbar-thumb {
      background: ${colors.bluePrimary}66;
    }
    
    h4 {
      margin: 4px 0;
    }

    .button-container {
        display: flex;
    }

    .button-container :global(.button){
      margin-top: 0.5rem;
      height: 28px;
      font-size: 12px;
      background: ${colors.formGrey};
      color: ${colors.darkSecondary};
      margin-left: 0.5rem;
    }

    .button-container :global(.button.green){
        background: ${colors.green};
        color: ${colors.white};
      }

    .button-container :global(.button):hover{
      background: ${colors.borderGrey};
    }

    .button-container :global(.button.green):hover{
        background: ${colors.green};
      }

    `}</style>
        </>
    )
}

export default AppointmentScheduler;

export const Route = createFileRoute('/_authenticated/appointment/scheduler')({ component: AppointmentScheduler })
